// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"IM-z","smallCardRow":"JM-z","largeCardRow":"KM-z","productSearchRow":"LM-z","curatedRow":"MM-z"};